<div class="map-links-container">
  <!-- Header -->
  <div class="header" *ngIf="isAdmin">
    <button class="add-btn" (click)="openModal()">
      <i class="fas fa-plus"></i>
      Add Link
    </button>
  </div>

  <!-- Links Grid -->
  <div class="links-grid" *ngIf="mapLinks.length > 0 && !isLoading">
    <div class="link-card" *ngFor="let link of mapLinks" (click)="openLink(link)">
      <div class="card-content">
        <div class="card-info">
          <h3 class="card-title">{{ link.title }}</h3>
          <p class="card-url">{{ link.url }}</p>
        </div>
        <div class="card-actions" *ngIf="isAdmin">
          <button class="delete-btn" (click)="deleteLink(link.id); $event.stopPropagation()" title="Delete link">
            <i class="fas fa-trash"></i>
          </button>
        </div>
      </div>
      <div class="icon-container">
        <i [class]="getIconClass(link.icon, link.iconType)"></i>
      </div>
      <div class="card-overlay">
        <i class="fas fa-external-link-alt"></i>
      </div>
    </div>
  </div>
</div>

<!-- Modal Template -->
<ng-template #addLinkModal>
  <div class="add-link-modal">
    <div class="add-link-modal__header">
      <h5 class="add-link-modal__title">
        <i class="fa-solid fa-plus me-2"></i>
        Add New Link
      </h5>
      <button class="add-link-modal__close" (click)="closeModal()">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>

    <div class="add-link-modal__body">
      <form (ngSubmit)="addLink()">
        <!-- Title Field -->
        <div class="form-group">
          <label for="title">Title *</label>
          <input type="text" id="title" [(ngModel)]="newLink.title" name="title" placeholder="Enter link title" required />
        </div>

        <!-- URL Field -->
        <div class="form-group">
          <label for="url">URL *</label>
          <input type="url" id="url" [(ngModel)]="newLink.url" name="url" placeholder="https://example.com" required />
        </div>

        <!-- Icon Selection -->
        <div class="form-group">
          <label for="icon">Select Icon</label>
          <select id="icon" [(ngModel)]="newLink.icon" name="icon" class="icon-select">
            <option *ngFor="let option of iconOptions" [value]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <!-- New Tab Option -->
        <div class="form-group">
          <label class="checkbox-label">
            <input type="checkbox" [(ngModel)]="newLink.openInNewTab" name="openInNewTab" />
            <span class="checkmark"></span>
            Open in new tab
          </label>
        </div>
      </form>
    </div>

    <div class="add-link-modal__footer">
      <button type="button" class="btn btn-primary" (click)="addLink()" [disabled]="!newLink.title || !newLink.url">
        <i class="fa-solid fa-plus mr-1"></i>
        Add Link
      </button>
    </div>
  </div>
</ng-template>
